import { API_URL } from "@/shared/config";

export const PAYMENT_ENDPOINTS = {
  HANDSHAKE: `${API_URL}/payment/handshake/`,
  CREATE_PAYMENT: (buildingId: number, cartType: string) =>
    `${API_URL}/payment/${buildingId}/${cartType}/create-payment/`,
  PAYMENT_STATUS: (buildingId: number, cartType: string, cartId: number) =>
    `${API_URL}/payment/${buildingId}/${cartType}/${cartId}/status/`,
  PAYMENT_STREAM: (buildingId: number, cartType: string, cartId: number) =>
    `${API_URL}/payment/${buildingId}/${cartType}/${cartId}/stream/`,
  CONFIRM_PAYMENT: (buildingId: number, cartType: string, cartId: number) =>
    `${API_URL}/payment/${buildingId}/${cartType}/${cartId}/confirm/`,
  DELETE_CART: (buildingId: number, cartType: string, cartId: number) =>
    `${API_URL}/payment/${buildingId}/${cartType}/${cartId}/delete/`,
};

export const CART_ENDPOINTS = {
  CHECKOUT: (buildingId: number) =>
    `${API_URL}/cart/${buildingId}/cart/checkout/`,
  LIST: (buildingId: number) => `${API_URL}/cart/${buildingId}/cart/`,
  ADMIN_LIST: (buildingId: number) =>
    `${API_URL}/cart/${buildingId}/cart/admin/`,
};

export const CARTBAR_ENDPOINTS = {
  CHECKOUT: (buildingId: number) =>
    `${API_URL}/cartBar/${buildingId}/cartBar/checkout/`,
  LIST: (buildingId: number) => `${API_URL}/cartBar/${buildingId}/cartBar/`,
  ADMIN_LIST: (buildingId: number) =>
    `${API_URL}/cartBar/${buildingId}/cartBar/admin/`,
};

export type PaymentStatus =
  | "idle"
  | "creating"
  | "processing"
  | "success"
  | "failed"
  | "cancelled";

export interface PaymentState {
  status: PaymentStatus;
  paymentUrl?: string;
  paymentId?: string;
  error?: string;
}

export interface CreatePaymentResponse {
  id?: number;
  payment_url?: string;
  payment_id?: string;
  cart_id?: number;
  url?: string;
  link?: string;
  short_url?: string;
  data?: {
    payment_url?: string;
    url?: string;
    link?: string;
    short_url?: string;
    [key: string]: any;
  };
}

// SSE Event Types
export interface SSEPaymentEvent {
  status: string;
  cart_id: number;
  cart_type: string;
  timestamp: string;
  event_type: 'initial' | 'status_change' | 'heartbeat' | 'timeout' | 'error';
  previous_status?: string;
  error?: string;
  message?: string;
  connection_duration?: number;
}
